import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const AdminAddToGroupIcon = (props: IconProps) => (
  <Icon width="16px" height="16px" viewBox="0 0 16 16" {...props}>
    <path d="M5.373 6.4h-2V4.48H2.04V6.4h-2v1.28h2V9.6h1.333V7.68h2V6.4Zm6.667.64c1.107 0 1.993-.857 1.993-1.92 0-1.062-.886-1.92-1.993-1.92-.213 0-.42.032-.607.09.38.518.6 1.145.6 1.83s-.226 1.306-.6 1.83c.187.058.394.09.607.09Zm-3.333 0c1.106 0 1.993-.857 1.993-1.92 0-1.062-.887-1.92-1.993-1.92-1.107 0-2 .858-2 1.92 0 1.063.893 1.92 2 1.92Zm4.413 1.383c.553.467.92 1.062.92 1.817v1.28h2v-1.28c0-.985-1.58-1.593-2.92-1.817ZM8.707 8.32c-1.334 0-4 .64-4 1.92v1.28h8v-1.28c0-1.28-2.667-1.92-4-1.92Z" />
  </Icon>
);

export default memo(AdminAddToGroupIcon);
